import { autoinject, BindingEngine, customElement } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { DeviationRequestFormCustomElement } from "components/deviation-request-form";
import { SingleInstanceDeviationRequest } from "model/forms/deviation-request";
import { SystemUserWrapper } from 'model/support-types';
import { EnumsService } from 'services/enums-service';
import { KeywordsService } from 'services/keywords-service';
import { LookupsService } from 'services/lookups-service';
import { MAX_DATE } from '../support/settings';

@autoinject
@customElement('single-instance-deviation-request-form')
export class SingleInstanceDeviationRequestFormCustomElement extends DeviationRequestFormCustomElement<SingleInstanceDeviationRequest> {
  newEmptyTraveller: SystemUserWrapper = { user: null, userId: null };
  public today = new Date().toISOString().slice(0, 10);
  public maxDate = MAX_DATE.toISOString().slice(0, 10);

  constructor(bindingEngine: BindingEngine, protected lookups: LookupsService, protected keywords: KeywordsService, protected enums: EnumsService) {
    super(bindingEngine, lookups, keywords, enums);
  }

  modelChanged(newValue: SingleInstanceDeviationRequest) {
    super.modelChanged(newValue);
    this.newEmptyTraveller = { user: null } as SystemUserWrapper;
    ValidationRules
      .ensureObject<SingleInstanceDeviationRequest>().required()
      .ensure(model => model.requestedBy).displayName('Requested By').required()
      .ensure(model => model.lineManagerName).displayName('Line Manager').required()
      .ensure(model => model.isSupportedByLineManager).satisfies(value => value != null && value === true).withMessage('Approval from your Line Manager is required.')
      .ensure(model => model.organisationEntity).displayName('Organisation').required()
      .ensure(model => model.validFrom).displayName('Valid From').required().satisfiesRule('maxDate')
      .ensure(model => model.validTo).displayName('Valid To').required().satisfiesRule('minDate').satisfiesRule('maxDate')
      .ensure(model => model.travellers).displayName('Travellers').minItems(1).withMessage('At least one Traveller is required.')
      .ensure(model => model.isSupportedByEpra).satisfies(value => value != null && value === true).when(() => this.workflowStrategy.hasEpra).withMessage('Approval from your EPRA is required.') //workaround validation from DeviationRequestEpraPanelCustomElement
      .on(this.model);
  }
}
